import React, { useRef } from 'react';

import type { TeaserListProps } from '../../../../components/teasers/TeaserList.js';
import type { TopListView } from '../types.js';

import Image from '../../../../components/teasers/teaserComponents/Image.js';
import TeaserWrapper from '../../../../components/teasers/TeaserWrapper.js';
import { useIntersectionObserver } from '../../../../hooks/useIntersectionObserver.js';

type TopListRelatedTeaserProps = {
  teaser: TeaserListProps;
  view: TopListView;
  onView?: () => void;
};

const TopListRelatedTeaser: React.FC<TopListRelatedTeaserProps> = ({
  teaser,
  view,
  onView,
}) => {
  const teaserRef = useRef<HTMLDivElement>(null);

  const { properties } = teaser;
  const { image, title } = properties;

  const link = `${teaser.extraPath ?? ''}${teaser.id.replace('.', '/')}`;

  useIntersectionObserver(teaserRef, onView);

  return (
    <TeaserWrapper
      classNames={`top-list__teaser-wrapper top-list__teaser-wrapper--related top-list__teaser-wrapper--${view}`}
      teaser={teaser}
      link={link}
    >
      <div className="top-list__teaser-info" ref={teaserRef}>
        {image && (
          <figure className="top-list__teaser-image">
            <Image
              imageAsset={{ id: image }}
              width={120}
              height={120}
              title={title}
            />
          </figure>
        )}
        <h3 className="top-list__teaser-kicker top-list__teaser-kicker--related">
          {title}
        </h3>
      </div>
      <p className="top-list__teaser-map-button">Sjekk på kartet</p>
    </TeaserWrapper>
  );
};

export { TopListRelatedTeaser };
